import { render } from "./PanchayatSamiti.vue?vue&type=template&id=cad7a1e4&scoped=true"
import script from "./PanchayatSamiti.vue?vue&type=script&lang=js"
export * from "./PanchayatSamiti.vue?vue&type=script&lang=js"

import "./PanchayatSamiti.vue?vue&type=style&index=0&id=cad7a1e4&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cad7a1e4"]])

export default __exports__